'use client';

import { ContentDialog } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';

import './linking-guide-animation.css';

function CursorIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4 1L4 15L8.5 10.5L13 18L15.5 16.5L11 9L17 9L4 1Z"
        fill="var(--sys-cont-none-light)"
        stroke="var(--sys-cont-neutral-default)"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TrackRow({ bgClass }: { bgClass: string }) {
  return (
    <div className="relative h-[28px] w-full">
      <div
        className={`absolute top-0 left-0 h-full w-[84px] rounded-[5.6px] ${bgClass}`}
      />
      <div
        className={`animate-linking-clip-b absolute top-0 z-10 h-full w-[140.7px] rounded-[5.6px] ${bgClass}`}
      />
      <div
        className={`animate-linking-clip-c absolute top-0 h-full w-[169.7px] rounded-[5.6px] ${bgClass}`}
      />
    </div>
  );
}

function LinkingAnimation() {
  return (
    <div className="relative h-[160px] w-full overflow-hidden rounded-sm bg-sys-bg-surface-2">
      <div className="absolute top-0 left-1/2 h-full w-[400px] -translate-x-1/2">
        <div className="absolute top-[39px] left-0 flex w-full flex-col gap-[2.8px]">
          <TrackRow bgClass="bg-sys-style-primary-default" />
          <TrackRow bgClass="bg-comp-label-yellow-bg" />
          <TrackRow bgClass="bg-comp-label-green-bg" />
        </div>

        <div className="animate-linking-cursor absolute top-[76px] z-20">
          <CursorIcon />
        </div>
      </div>
    </div>
  );
}

interface LinkingGuideDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LinkingGuideDialog({
  open,
  onOpenChange,
}: LinkingGuideDialogProps) {
  const t = useTranslations();

  return (
    <ContentDialog
      open={open}
      setOpen={onOpenChange}
      titleNode={t('Editor.timeline-controls.linking-guide-title')}
      descriptionNode={t('Editor.timeline-controls.linking-guide-description')}
      subTextNode={t('Editor.timeline-controls.linking-guide-sub')}
      isShowCancelButton={false}
      confirmText={t('Editor.timeline-controls.linking-guide-confirm')}
      onConfirm={() => onOpenChange(false)}
      contentClassName="w-[600px] max-w-[calc(100vw-48px)]"
    >
      <LinkingAnimation />
    </ContentDialog>
  );
}
